var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPuzzle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3.11,6.44 L 6.44,6.44 A 1.11,1.11 0 0,0 7.56,5.33 L 7.56,4.22 A 2.22,2.22 0 0,1 12,4.22 L 12,5.33 A 1.11,1.11 0 0,0 13.11,6.44 L 16.44,6.44 A 1.11,1.11 0 0,1 17.56,7.56 L 17.56,10.89 A 1.11,1.11 0 0,0 18.67,12 L 19.78,12 A 2.22,2.22 0 0,1 19.78,16.44 L 18.67,16.44 A 1.11,1.11 0 0,0 17.56,17.56 L 17.56,20.89 A 1.11,1.11 0 0,1 16.44,22 L 13.11,22 A 1.11,1.11 0 0,1 12,20.89 L 12,19.78 A 2.22,2.22 0 0,0 7.56,19.78 L 7.56,20.89 A 1.11,1.11 0 0,1 6.44,22 L 3.11,22 A 1.11,1.11 0 0,1 2,20.89 L 2,17.56 A 1.11,1.11 0 0,1 3.11,16.44 L 4.22,16.44 A 2.22,2.22 0 0,0 4.22,12 L 3.11,12 A 1.11,1.11 0 0,1 2,10.89 L 2,7.56 A 1.11,1.11 0 0,1 3.11,6.44",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPuzzle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/puzzle.388ae059.svg";
export { ForwardRef as ReactComponent };